var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 1 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 7.79489V22.9616M14.5 7.79489C13.1375 6.88965 11.2876 6.33331 9.25 6.33331C7.21243 6.33331 5.36254 6.88965 4 7.79489V22.9616C5.36254 22.0563 7.21243 21.5 9.25 21.5C11.2876 21.5 13.1375 22.0563 14.5 22.9616M14.5 7.79489C15.8625 6.88965 17.7124 6.33331 19.75 6.33331C21.7876 6.33331 23.6375 6.88965 25 7.79489V22.9616C23.6375 22.0563 21.7876 21.5 19.75 21.5C17.7124 21.5 15.8625 22.0563 14.5 22.9616",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.dc0d546e0702d5fe13957110f2a4e1d8.svg";
export { ForwardRef as ReactComponent };